import React from 'react';
import Image from 'components/AppImage';

const ALUMNI_AVATARS = [
{
  src: "https://randomuser.me/api/portraits/women/44.jpg",
  alt: 'Professional woman with curly brown hair smiling in office setting wearing blazer'
},
{
  src: "https://randomuser.me/api/portraits/men/32.jpg",
  alt: 'Professional man with short dark hair in navy suit against neutral background'
},
{
  src: "https://randomuser.me/api/portraits/women/68.jpg",
  alt: 'Young professional woman with straight black hair in white blouse at desk'
},
{
  src: "https://randomuser.me/api/portraits/men/67.jpg",
  alt: 'Middle-aged professional man with glasses and grey shirt in corporate setting'
},
{
  src: "https://randomuser.me/api/portraits/women/11.jpg",
  alt: 'Professional woman with blonde hair in formal attire against light background'
}];


export default function SocialProof() {
  return (
    <div className="flex flex-col items-center gap-3">
      <div className="flex items-center">
        {ALUMNI_AVATARS?.map((avatar, idx) =>
        <div
          key={idx}
          className="w-8 h-8 rounded-full overflow-hidden border-2 border-card flex-shrink-0"
          style={{ marginLeft: idx === 0 ? 0 : '-8px', zIndex: ALUMNI_AVATARS?.length - idx }}>
          
            <Image
            src={avatar?.src}
            alt={avatar?.alt}
            className="w-full h-full object-cover" />
          
          </div>
        )}
        <div
          className="w-8 h-8 rounded-full flex items-center justify-center border-2 border-card flex-shrink-0 text-xs font-body font-500"
          style={{
            marginLeft: '-8px',
            background: 'var(--color-primary)',
            color: 'var(--color-primary-foreground)',
            zIndex: 0
          }}>
          
          +2k
        </div>
      </div>
      <p className="text-xs font-caption text-center" style={{ color: 'var(--color-text-secondary)' }}>
        Join <span className="font-500" style={{ color: 'var(--color-foreground)' }}>12,400+</span> alumni already connected
      </p>
    </div>);

}